export default __webpack_public_path__ + "media/projects/blue3-a89c749d.svg";